<template>
  <div class="card w-100">
    <div class="card-header view">
      <div class="header">
        <div class="title">
          <div>Upload History</div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <VClientTable
          :class="{'hide-filters': true}"
          class="mb-4"
          :data="safeTableData"
          :columns="tableColumns"
          :options="tableOptions"
          ref="fileProcessTable"
      >
        <template #status="{ row }">
          <div class="status" :class="getStatusClass(row.status)">
            {{ row.status.split('.').pop().toLowerCase() }}
          </div>
        </template>
        <template #actions="{ row }">
          <div>
            <StudiesDropdown
              :file-process-id="row.id"
              :go-to-file-process-details="goToFileProcessDetails"
            />
          </div>
        </template>
      </VClientTable>
    </div>
  </div>
</template>

<script>
import StudiesDropdown from '@/components/StudiesUpload/StudiesDropdown'
import VClientTable from '@/components/shared/VClientTable'

export default {
  name: 'StudiesUploadHistory',
  components: { StudiesDropdown, VClientTable },
  props: {
    tableData: Array,
    goToFileProcessDetails: Function
  },
  data () {
    return {
      tableColumns: [
        'created_at',
        'client',
        'study_type',
        'pace_number',
        'year',
        'region',
        'status',
        'actions'
      ],
      tableOptions: {
        headings: {
          pace_number: 'Pace #'
        }
      },
      fileProcessStatusClass: {
        'UPLOADED': 'status-uploaded',
        'UNPACKED': 'status-unpacked',
        'VALIDATED': 'status-validated',
        'INJECTED': 'status-injected',
        'ERRORED': 'status-error',
        'SUCCEED': 'status-succeed'
      }
    }
  },
  computed: {
    safeTableData () {
      return Array.isArray(this.tableData) ? this.tableData : []
    }
  },
  methods: {
    getStatusClass (fileStatus) {
      const status = fileStatus.split('.').pop()
      return this.fileProcessStatusClass[status]
    }
  }

}
</script>
<style lang="scss">
@import '../../assets/scss/variables';
.VuePagination {
  nav {
    display: flex;
    .VuePagination__pagination {
      display: flex;
      .VuePagination__pagination-item {
        font-family: 'Source Sans Pro', sans-serif;
        font-weight: 400;
        font-size: 13px;
        margin: 0 4px;
        padding: 0;
        a {
          color: rgba(77, 79, 92, 0.51) !important;
          border: 1px solid #E8E9EC !important;
          border-radius: 4px !important;
        }
      }
      .active {
        a {
          background-color: #e4e5e6 !important;
        }
      }
    }
    .VuePagination__count {
      line-height: 35px;
      text-align: left !important;
      color: $pewter !important;
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 400;
      font-size: 14px;
    }
  }
}
</style>
<style scoped lang="scss">
@import '../../assets/scss/variables';
.hide-filters {
  .VueTables__search-field {
    display: none !important;
  }
  .vgt-global-search {
    display: none !important;
  }
  .after-filter-wrapper {
    width: 100%;
    justify-content: flex-end;
    .info-text {
      margin-right: 15px;
    }
  }
}
.status {
  border: none;
  border-radius: .3rem;
  padding: .25rem .35rem;
  text-align: center;
}

.status-injected {
  color: $soot;
  background-color: $blue-500;
}
.status-succeed {
  color: $white;
  background-color: $green-600;
}
.status-error {
  color: $soot;
  background-color: $orange-400;
}
.status-uploaded {
  color: $white;
  background-color: $celery-400;
}
.status-unpacked {
  color: $white;
  background-color: $magenta-400;
}
.status-validated {
  color: $white;
  background-color: $fuchsia-400;
}
.view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  padding-bottom: 1rem;

  .header {
    display: flex;
    justify-content: space-between;
  }
}
.title {
  margin-top: 20px;
  margin-left: 32px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 30px;
  line-height: 24px;
  letter-spacing: 0.8px;
  @media screen and (min-width: $break-lg) {
    font-size: 35px;
    line-height: 26px;
    letter-spacing: 0.8px;
    margin-top: 23px;
    margin-left: 37px;
  }
  @media screen and (min-width: $break-xl) {
    font-size: 40px;
    line-height: 28px;
    letter-spacing: 0.9px;
    margin-top: 26px;
    margin-left: 42px;
  }
  @media screen and (min-width: $break-xxl) {
    font-size: 45px;
    line-height: 30px;
    letter-spacing: 0.9px;
    margin-top: 29px;
    margin-left: 47px;
  }
  color: $pewter;
  text-transform: uppercase;
}

</style>
